import {ITokenStorageService} from './token-storage.service';
import {IAccessTokenApi} from '../api/access-token-api.service';
import {Set} from 'immutable';
import {StateService} from 'angular-ui-router';

export interface ILoginStateChangeListener {
  (loggedIn:boolean):void;
}

export namespace ILoginService {
  export const UNAUTHORIZED_EVENT_NAME = 'imomo-unauthorized';
  export const LOGIN_EVENT_NAME = 'imomo-login';
  export const LOGOUT_EVENT_NAME = 'imomo-logout';
}

export interface ILoginService {
  isLoggedIn():boolean;
  logInUser(username:string, password:string):ng.IPromise<void>;
  logOutUser():ng.IPromise<void>;
  onLoginStateChange(listener:ILoginStateChangeListener):() => void;
}


export default class LoginService implements ILoginService {
  static $inject = ['tokenStorageService', 'accessTokenApi',
    '$log', '$q', '$rootScope', '$state'];

  private accessTokenPromise:ng.IPromise<void>;
  private accessTokenPromiseInProgress:boolean;
  private loginStateChangeListeners:Set<ILoginStateChangeListener>;

  constructor(private tokenStorageService:ITokenStorageService,
              private accessTokenApi:IAccessTokenApi,
              private $log:ng.ILogService,
              private $q:ng.IQService,
              private $rootScope:ng.IRootScopeService,
              private $state:StateService) {
    this.accessTokenPromise = null;
    this.accessTokenPromiseInProgress = false;
    this.loginStateChangeListeners = Set<ILoginStateChangeListener>();
    this.$rootScope.$on(ILoginService.UNAUTHORIZED_EVENT_NAME, () => {
      this.onUnauthorizedError();
    });
  }

  isLoggedIn() {
    return this.tokenStorageService.verifyToken();
  }

  onLoginStateChange(listener:ILoginStateChangeListener) {
    this.loginStateChangeListeners =
        this.loginStateChangeListeners.add(listener);
    return () => {
      this.loginStateChangeListeners =
          this.loginStateChangeListeners.delete(listener);
    }
  }

  logInUser(username:string, password:string) {
    const result = this.$q.defer<void>();
    if (this.accessTokenPromiseInProgress) {
      this.accessTokenPromise
          .then(() => result.resolve())
          .catch(() => result.reject());
    } else if (this.tokenStorageService.verifyToken()) {
      result.reject();
    } else {
      this.accessTokenPromiseInProgress = true;
      this.accessTokenPromise = this.accessTokenApi
          .getUserToken(username, password)
          .then(accessToken => {
            this.tokenStorageService.setToken(accessToken);
            this.notifyListeners(true);
            result.resolve();
          })
          .catch(reason => {
            result.reject(reason);
          })
          .finally(() => {
            this.accessTokenPromiseInProgress = false;
          });
    }
    return result.promise;
  }

  logOutUser() {
    this.$rootScope.$broadcast(ILoginService.LOGOUT_EVENT_NAME);
    this.tokenStorageService.clearToken();
    this.notifyListeners(false);
    return this.$q.when();
  }

  private notifyListeners(loggedIn:boolean) {
    this.loginStateChangeListeners.forEach(listener => listener(loggedIn));
  }

  private onUnauthorizedError() {
    this.logOutUser().then(() => {
      this.$state.go('home')
    });
  }
}



/** WEBPACK FOOTER **
 ** ./app/auth/login.service.ts
 **/